export const STOP_TYPE = {
  DROPOFF: 'DROP_OFF',
  PICKUP: 'PICK_UP',
};
